// extracted by mini-css-extract-plugin
export default {"navbar":"styles_navbar__Nh8JO","page":"styles_page__QIvQr"};